export const useAuthAdminGetters = () => {
  return ref();
};
